export function generateStandingOfferURL(id: string) {
  const baseURL = window.location.origin;
  const offerURL = `${baseURL}/standing-offer/${id}`;

  return offerURL;
}
